import { parse, format } from '@formkit/tempo';

export const formatDateRange = (
  fullStartDateTime: string,
  fullEndDateTime: string,
  isOngoingEvent: boolean,
) => {
  const formattedStartDate = fullStartDateTime.split(', ')[0]!;
  const formattedEndDate = fullEndDateTime.split(', ')[0]!;
  const spansMultipleDays = formattedStartDate !== formattedEndDate;

  const formattedStartDateTime = isOngoingEvent
    ? fullStartDateTime.split(', ')[0]!
    : fullStartDateTime;
  const formattedEndDateTime = isOngoingEvent
    ? fullEndDateTime.split(', ')[0]!
    : spansMultipleDays
    ? fullEndDateTime
    : fullEndDateTime.split(', ')[1]!;

  const removeZeros = (d: string) => d.replace(':00', '');

  const datetimeWithZerosRemoved = [
    formattedStartDateTime,
    formattedEndDateTime,
  ].map(removeZeros);

  return datetimeWithZerosRemoved;
};

// Change the UTC time to the local time in New York City by removing Z
export const getNewYorkDateTime = (dateTimeISOString?: string) => {
  const dateTimeWithoutZuluOffset = dateTimeISOString?.replace('Z', '');

  // Parse the ISO 8601 string into a Date object
  const parsedDate = parse(
    dateTimeWithoutZuluOffset ?? '',
    'YYYY-MM-DDTHH:mm:ss',
  );

  return parsedDate;
};

export const getMonthStartEndDate = (year: number, month: number) => {
  const nyFirstOfMonthDate = new Date(year, month - 1, 1);
  const nyLastOfMonthDate = new Date(year, month, 0);

  return {
    monthStart: nyFirstOfMonthDate,
    monthEnd: nyLastOfMonthDate,
  };
};

export const isInSunsetHoursLimit = (hour: number) => {
  // sunset assumed to be between 3pm and 10pm
  return hour >= 15 && hour <= 18;
};

// TODO: Create unit test for this function - 1st of month, last of month, leap year, etc.
export const formatToLongDate = ({
  dateTime,
  includesDayOfWeek = false,
  longMonth = false,
  locale = 'en-US',
}: {
  dateTime: string;
  includesDayOfWeek?: boolean;
  longMonth?: boolean;
  locale?: string;
}) => {
  try {
    const parsedDate = parse(dateTime);

    let formatString = '';
    if (includesDayOfWeek) {
      formatString += 'dddd ';
    }
    formatString += longMonth ? 'MMMM' : 'MMM';
    formatString += ' D, YYYY';

    return format(parsedDate, formatString, locale); // Pass the locale here
  } catch (error: unknown) {
    console.warn(
      'Unable to format date: ' +
        (error instanceof Error ? error.message : String(error)),
    );
    return '';
  }
};

/**
 * Converts a year, month, and day into a formatted date string.
 * @param year The full year (e.g., 2024)
 * @param month The month (0-11). Note: This is zero-indexed, where 0 represents January.
 * @param day The day of the month (1-31)
 * @returns A formatted date string in the format "YYYY-MM-DD"
 */
export const getDateString = (year: number, month: number, day: number) => {
  const _month = String(month + 1).padStart(2, '0');
  const _day = String(day).padStart(2, '0');
  return `${year}-${_month}-${_day}`;
};
